const cardTypes = {
  alreadyRead: 'alreadyRead',
  reading: 'reading',
  goingToRead: 'goingToRead',
};

export default cardTypes;
